import { Injectable } from '@angular/core';
import { ErrorCodes, MediaFolder, ConfigStrings, MediaTranslation } from 'src/app/utils/common-classes';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../Auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  constructor(private httpClient: HttpClient, private authService: AuthService) { }


  public getFolders(mediaFolderId: string, mediaTreeId: string): Promise<Array<MediaFolder>> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      let params = new HttpParams();
      if (mediaFolderId) {
        params = params.append('parentFolderId', mediaFolderId);
      }
      params = params.append('mediaTreeId', mediaTreeId);

      _self.httpClient.get(ConfigStrings.API_URL + "/get-folders", { headers: headers, params: params }).subscribe((data: Array<MediaFolder>) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public createFolder(name: string, parentFolderId: string, mediaTreeId: string): Promise<MediaFolder> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      const body = {
        name: name,
        parentFolderId: parentFolderId,
        mediaTreeId: mediaTreeId
      };
      _self.httpClient.post(ConfigStrings.API_URL + "/create-folder", body, { headers: headers }).subscribe((data: MediaFolder) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public renameFolder(name: string, mediaFolderId: string): Promise<MediaFolder> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      const body = {
        mediaFolderId: mediaFolderId,
        name: name
      };
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-folder", body, { headers: headers }).subscribe((data: MediaFolder) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public moveFolder(mediaFolderId: string, parentFolderId: string): Promise<MediaFolder> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      const body = {
        mediaFolderId: mediaFolderId,
        parentFolderId: parentFolderId ? parentFolderId : ""
      };
      _self.httpClient.post(ConfigStrings.API_URL + "/edit-folder", body, { headers: headers }).subscribe((data: MediaFolder) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public deleteFolder(mediaFolderId: string): Promise<void> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      const body = {
        mediaFolderId: mediaFolderId
      };
      _self.httpClient.post(ConfigStrings.API_URL + "/delete-folder", body, { headers: headers }).subscribe(() => {
        resolve();
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public setFolderTranslation(mediaTranslation: MediaTranslation): Promise<MediaFolder> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/set-folder-translation", mediaTranslation, { headers: headers }).subscribe((data: MediaFolder) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public deleteTranslation(mediaTranslation: MediaTranslation): Promise<MediaFolder> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.authService.getHeaders();
      _self.httpClient.post(ConfigStrings.API_URL + "/delete-folder-translation", mediaTranslation, { headers: headers }).subscribe((data: MediaFolder) => {
        if (data) {
          resolve(data);
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

}
